
import {empty as observableEmpty, of as observableOf,  Observable } from 'rxjs';

import {mergeMap,  flatMap } from 'rxjs/operators';
import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { MatSnackBar,MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { AppService } from '../commons/app.service';
import { AppRoutes } from '../commons/global';
import { TranslateService } from '@ngx-translate/core'
import { FourDService } from '4d-mapper';
import {BaseComponent} from '../commons/BaseComponent';

import { XsApplicationEventsService } from '../xs/services/events/application-events.service';
import { LoadingSpinner } from '../commons/ui/loading-spinner';

@Component({
    selector: 'auth-comp',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss']
})
export class AuthComponent  extends BaseComponent {

    prevpage:string[]
    prevpageStr:string
    toBooking:boolean
    displayName:string

    emailControl    = new FormControl('', [Validators.required, Validators.email])
    passControl     = new FormControl('', [Validators.required, Validators.pattern('[A-Za-z0-9_]{6,}')])
    username:string
    password:string
    // Helper variables
    errorMessage:string
    errorNoEmail:string
    errorSocialMedia:string
    successMessage:string
    successAction:string
    changeServer = 0;

    showFacebook:any
    showGoogle:any

    constructor(public service:AppService, public router:Router,private ar:ActivatedRoute,public location:Location, public snackBar: MatSnackBar, 
        public dialog: MatDialog, public translate: TranslateService, applicationEvents:XsApplicationEventsService){
        super(router, snackBar, dialog)
        this.openEdgeWarningDialog();
        this.service.V.config.clientId = '4dmapper'
        delete localStorage['last4d_token']
        delete localStorage['last4d_secret']
        ar.params.subscribe(p => {
            if(p.message)
                this.openSnackBarError(errorMessages[p.message] || p.message)
        })
        service.V.api('/access/login/4dmapper').subscribe(s => {
            this.showFacebook = s.remoteClients.find(c => c.client_id == 'facebook')
            this.showGoogle = s.remoteClients.find(c => c.client_id == 'google')
        })
        ar.queryParams.subscribe(p => {
                this.prevpageStr = p.prevpage
                if(p.prevpage){
                this.prevpage = p.prevpage.split(',')
                this.prevpage[0] = '/' + this.prevpage[0]
                }
                else{
                this.prevpage = null
                }
                this.toBooking = p.booking
        })

    }

    ngOnInit() {
        LoadingSpinner.end();
    }

    oauth(str:string){

        let host = window.location.origin + this.location.prepareExternalUrl("")
        console.log("ENTER redirect URL: " + host + "auth/oauth/" + str)

        this.service.V.loginViaOAuthUrl(str, host + "auth/oauth/" + str,this.prevpageStr)
            .subscribe(
            s => {
                document.location.href = s
            }, e => {
                console.log("ENTER error loginViaOauth")
                console.log(e)
            }
        )

        /*
        if (str == "google") {
            this.service.V.api('/access/remoteAuth/' + this.service.V.cfg.clientId + "/260359117038-6p2nsf2276gpm3podd477vbn80evbg7d.apps.googleusercontent.com.json")
                .map(r => r.url)
                .subscribe(
                    s => {
                        document.location.href = s
                    },
                    e => {
                        console.log(e)
                    }
                )
        }
        */
    }
/*
    navigateToRoute(route:string) {
        this.router.navigate([route],{
            queryParams:{prevpage:this.prevpageStr},
            replaceUrl:true
        })
    }
*/
    login(){
        this.loading = true;
        this.service.V.config.clientId = '4dmapper'
        delete localStorage['last4d_token']
        delete localStorage['last4d_secret']
        // Login users and then refresh api/me as well as bookings details.
        this.service.V.loginWithUsernameObservable(this.username,this.password).pipe(
            mergeMap(res => this.service.refreshMe()),
            mergeMap(res => this.service.refreshData()),)
            .subscribe(
                (r) => {
                    this.postLogin()
                }
                ,
                (e) => {
                    this.loading = false;
                    LoadingSpinner.end();
                  if(e.status == 403){
                    this.openSnackBarError("SIGNIN.WRONG_PASSWORD")
                  }else{
                    this.openSnackBarError(e.status + ": " + e.message, "GENERIC.OK")
                  }

                }
            )
    }
    postLogin(){
        this.loading = false;
        LoadingSpinner.end();
        if (this.prevpage) {
            this.router.navigate(this.prevpage || ['/'])
        } else {
            //console.log("navigating to app")
            this.router.navigateByUrl(AppRoutes.MAIN)
        }
    }

    openForgotDialog() {

        // Load translations needed
        this.translate.get(['SIGNIN.FORGOT','SIGNIN.FORGOT_DESC','SIGNIN.EMAIL_PLACEHOLDER','SIGNIN.EMAIL_ERROR','SIGNIN.FORGOT_SUCCESS','SIGNIN.FORGOT_ERROR_NO_EMAIL','SIGNIN.FORGOT_ERROR','SIGNIN.FORGOT_ERROR_SOCIAL_MEDIA']).pipe(
            mergeMap(trans => {
            
                // Keep reference to this success message needed further down. We do this so we don't call the translation services again.
                this.successMessage = trans['SIGNIN.FORGOT_SUCCESS']
                this.errorMessage   = trans['SIGNIN.FORGOT_ERROR']
                this.errorNoEmail   = trans['SIGNIN.FORGOT_ERROR_NO_EMAIL']
                this.errorSocialMedia   = trans['SIGNIN.FORGOT_ERROR_SOCIAL_MEDIA']
    
                let res = {
                    input :{
                        placeholder: trans['SIGNIN.EMAIL_PLACEHOLDER'],
                        value:this.username,
                        error: trans['SIGNIN.EMAIL_ERROR'],
                        copy:false
                    },
                    title: trans['SIGNIN.FORGOT'],
                    message: trans['SIGNIN.FORGOT_DESC']
                }
                return observableOf(res)
            }),mergeMap(res => {
                console.log(res)
                return this.openDialog(res.title, res.message, null, null, res.input, null)
            }),
            mergeMap(res => {
                console.log(res)
                if (res) {
                    this.loading = true
                    return this.service.V.forgetPasswordObservable(res.toString())
                } else {
                    return observableEmpty()
                }
            }),)
            .subscribe(
                (succ) => {
                    this.loading = false
                    LoadingSpinner.end();
                    this.openSnackBarSuccess(this.successMessage)
                }
                ,
                (err) => {
                    console.log(err)
                    this.loading = false;
                    LoadingSpinner.end();
                    if (err.status == 412)
                        this.openSnackBarWarn(err.status + ": " + this.errorNoEmail)
                    else if(err.status == 41001)
                        this.openSnackBarWarn(err.status + ": " + this.errorSocialMedia)
                     
                    else
                        this.openSnackBarError(err.status + ": " + this.errorMessage)
                }
            )
    }

    openRegisterDialog() {
        // Load translations needed
        this.translate.get(['SIGNIN.REGISTER_TITLE','SIGNIN.REGISTER_DESC','SIGNIN.EMAIL_PLACEHOLDER','SIGNIN.EMAIL_ERROR','SIGNIN.REGISTER_SUCCESS','SIGNIN.REGISTER_EMAIL_ERR','SIGNIN.REGISTER_ERROR','GENERIC.OK']).pipe(
            mergeMap(trans => {
                //console.log(trans)
                // Keep reference to this success message needed further down. We do this so we don't call the translation services again.
                this.successMessage = trans['SIGNIN.REGISTER_SUCCESS']
                this.errorMessage   = trans['SIGNIN.REGISTER_ERROR']
                this.errorNoEmail   = trans['SIGNIN.REGISTER_EMAIL_ERR']
                this.successAction  = trans['GENERIC.OK']
                let res = {
                    input :{
                        placeholder: trans['SIGNIN.EMAIL_PLACEHOLDER'],
                        value:"",
                        error: trans['SIGNIN.EMAIL_ERROR'],
                        copy:false
                    },
                    title: trans['SIGNIN.REGISTER_TITLE'],
                    message: trans['SIGNIN.REGISTER_DESC']
                }
                return observableOf(res)
            }),mergeMap(res => {
                console.log(res)
                return this.openDialog(res.title, res.message, null, null, res.input, null)
            }),
            mergeMap(res => {
                if (res) {
                    this.loading = true
                    return this.service.requestEmailRegistration(res.toString())
                } else {
                    return observableEmpty()
                }
            }),)
            .subscribe(
                (succ) => {
                    this.loading = false
                    LoadingSpinner.end();
                    this.openDialog('SIGNIN.REGISTER_SUCCESS','','GENERIC.OK').subscribe()
                }
                ,
                (err) => {
                    console.log(err)
                    this.loading = false;
                    LoadingSpinner.end();
                    if (err.status == 10011)
                        this.openSnackBarWarn(err.status + ": " + this.errorNoEmail)
                     else
                        this.openSnackBarError(err.status + ": " + this.errorMessage)
                }
            )
    }
}

@Component({
    selector: 'login-email',
    templateUrl: './email-login.component.html'

})
export class LoginEmailComponent extends AuthComponent {

    /*
    emailControl    = new FormControl('', [Validators.required, Validators.email])
    passControl     = new FormControl('', [Validators.required, Validators.pattern('[A-Za-z0-9_]{6,}')])
    username:string
    password:string
    prevpage:string[]
    prevpageStr:string
    // Helper variables
    errorMessage:string
    errorNoEmail:string
    successMessage:string


    constructor(public service:AppService, public router:Router,private ar:ActivatedRoute,public location:Location, public snackBar: MatSnackBar, public dialog: MatDialog, public translate: TranslateService){
        super(service, router, ar, location, snackBar, dialog, translate)


    }
    */
}

let errorMessages = {
  timeout:'You need to login to access this section'
}

@Component({
    selector: 'signup-comp',
    templateUrl: './email-signup.component.html'

})
export class SignupComponent extends BaseComponent {
    username:string
    password:string
    confirmPassword:string
    name:string

    loading:boolean = false
    terms:boolean = false
    error:any
    prevpage:string[]
    prevpageStr:string


    success:boolean
    constructor(private t:TranslateService, public service:AppService,public router:Router, private ar:ActivatedRoute, public snackBar: MatSnackBar, public dialog: MatDialog, applicationEvents:XsApplicationEventsService){
        super(router, snackBar, dialog)
        ar.queryParams.subscribe(p => {
            this.prevpageStr = p.prevpage
            if(p.prevpage){
              this.prevpage = p.prevpage.split(',')
              this.prevpage[0] = '/' + this.prevpage[0]
            }
            else{
              this.prevpage = null
            }
        })

    }

    signup(){
        if (this.password != this.confirmPassword) {
            this.t.get('SIGNIN.PASSWORD_MATCH').subscribe(s => 
                this.error = {message:s}
            )
            return
        }
        this.loading = true;
        this.service.V.signupWithObservable( this.username,this.password, {name:this.name,email:this.username}).pipe(
            mergeMap(res => this.service.refreshMe()),
            mergeMap(res => this.service.refreshData()),)
            .subscribe(
                (r) => {
                    this.postLogin()
                }
                ,
                (e) => {
                    if(e.status == 400 && e.payload && e.payload.error == 'access_denied'){
                        this.success = true
                    }
                    else{
                        this.error = e
                    }
                    this.loading = false;
                    LoadingSpinner.end();

                }
            )
    }

    postLogin(){
        this.loading = false
        LoadingSpinner.end();
        if (this.prevpage) {
            this.router.navigate(this.prevpage || ['/'])
        } else {
            //console.log("navigating to app")
            this.router.navigateByUrl('/play')
        }
    }
}
